import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Link, Route, Routes } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import ApiTesterApp from "./components/ApiTester/ApiTesterApp";
import ContentLayout from "./ContentLayout";
import classes from "./SpecialToolsApp.module.css";

const queryClient = new QueryClient();

const SpecialToolsApp = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/special-tools/">
        <ContentLayout>
          <div className={classes.root}>
            <h1>Special Tools!</h1>
            <nav>
              <Link to="/">Home</Link>
              <Link to="/api-tester-app">API Tester App</Link>
            </nav>
            <Routes>
              <Route path="/api-tester-app/*" element={<ApiTesterApp base="/api-tester-app" />} />
              <Route
                path="/"
                element={
                  <div>
                    <h2>Home</h2>
                    <p>Welcome!</p>
                  </div>
                }
              />
            </Routes>
          </div>
        </ContentLayout>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default SpecialToolsApp;
